import React from 'react';
import styled from '@emotion/styled';
import { EmotionBreakpoint } from 'dw-us-ui';

const BackgroundImage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 400px;
  position: relative;
  background-image: ${({ url }) => `url(${url})`};
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  opacity: 0.99;
  ${EmotionBreakpoint('mobile')} {
    .hero-banner-vineyard-inner {
      img {
        height: 34px !important;
      }
    }
    background-image: ${({ mobileUrl, url }) => `url(${mobileUrl || url})`};
    .banner-title {
      font-size: 24px;
      line-height: 34px;
    }
    .hero-banner-vineyard-info {
      padding: 0 32px;
    }
  }
  ${EmotionBreakpoint('tablet')} {
    .banner-title {
      font-size: 24px !important;
    }
  }
  .hero-banner-vineyard-inner {
    align-items: center;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
    img {
      z-index: 10;
      height: 55px;
      position: absolute;
    }
  }
  .hero-banner-vineyard-info {
    color: #fff;
    position: absolute;
    z-index: 10;
    margin-left: auto;
    margin-right: auto;
    left: 0;
    text-align: left;
    right: 0;
    bottom: 35px;
    padding: 0 5px;
    ${EmotionBreakpoint('desktop')} {
      max-width: 970px;
    }
    ${EmotionBreakpoint('tablet')} {
      max-width: 720px;
    }
    @media (min-width: 576px) and (max-width: 768px) {
      max-width: 540px;
    }
    .banner-title {
      font-size: 35px;
      ${EmotionBreakpoint('mobile')} {
        font-size: 19px;
        line-height: 34px;
      }
    }
    .banner-text {
      font-size: 18px;
      ${EmotionBreakpoint('mobile')} {
        line-height: 32px;
      }
    }
    h2 {
      margin-bottom: 1rem;
      line-height: 44px;
    }
  }
  .black-opacity {
    background: rgba(0, 0, 0, 0.5);
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
  }
`;

const HeroBanner = ({ bannerTitle, bannerText, bannerImage, bannerLogo, bannerMobileImage, opacity }) => {
  return (
    <BackgroundImage url={bannerImage} mobileUrl={bannerMobileImage}>
      <div className="hero-banner-vineyard-inner">
        {bannerLogo && <img src={bannerLogo} alt="Vineyard Partners Logo" />}
        <div className="hero-banner-vineyard-info">
          {bannerTitle && (
            <h2>
              <strong className="banner-title">{bannerTitle}</strong>
            </h2>
          )}
          {bannerText && !JSON.stringify(bannerText).includes('<h1></h1>') && (
            <p>
              <strong className="banner-text">{bannerText}</strong>
            </p>
          )}
        </div>
      </div>
      {opacity && <div className="black-opacity" />}
    </BackgroundImage>
  );
};

export { HeroBanner };
